// src/components/GuardedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import FullPageLoader from './FullPageLoader';

export default function GuardedRoute({ Component, roles }) {
    const { keycloak, initialized } = useKeycloak();
    const location = useLocation();

    if (!initialized) return <FullPageLoader />;

    // 1) não logado -> volta pro login
    if (!keycloak.authenticated) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    const has = (r) => keycloak.hasRealmRole(r);
    const isAdmin = has('ADMIN');
    const isGestor = has('GESTOR');

    // 2) se rota exigir papéis e o usuário não possui
    if (roles?.length && !roles.some(has)) {
        // GESTOR cai SEMPRE na área /external
        if (isGestor && !isAdmin) return <Navigate to="/external" replace />;
        // Admin (ou outros) caem em /home
        return <Navigate to="/home" replace />;
    }

    return <Component />;
}
